<div class="container-fluid">
    <div class="row">
      <div class="col-md-12 ">
        <div class="card">
          <div class="card-header text-center">
            <p class="h4  float-left">Pago proveedores</p>
            <a (click)="createPago()" class="btn btn-success float-right">
              Crear pago a proveedor</a
            >
          </div>

          <div class="card">
              <div class="col-md-12">
                <table
                  class="table table-condensed table-hover table-bordered"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <!-- <th>Foto</th> -->
                      <th>Nro Comprobante</th>
                      <th>Fecha de Pago</th>
                      <th>monto</th>
                      <th>proveedor</th>
  
                      <!--                  <th>Habilitado</th>-->
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let pago of pagos; let i = index">
                    <tr>
                      <th scope="row">
                        {{
                          i + 1 + (pago.current_page - 1) * pago.per_page
                        }}
                      </th>
                      <!-- <td>
                        <img
                          height="50"
                          width="50"
                          [src]="imageURL + 'client/' + client.foto"
                          alt=""
                        />
                      </td> -->
                      <td>{{ pago.nro_comprobante }}</td>
                      <td>{{ pago.fecha }}</td>
                      <td>{{ pago.monto }}</td>
                      <td>
                        nose
                      </td>
                      <!-- <td class="mt-2">
                  <label
                    class="switch switch_type1"
                    role="switch"
                    *ngIf="client.habilitado == true"
                  >
                    <input
                      type="checkbox"
                      class="switch__toggle"
                      (click)="enableClient(client.cliente_id)"
                      checked="false"
                    />
                    <span class="switch__label"></span>
                  </label>
                  <label
                    class="switch switch_type1"
                    role="switch"
                    *ngIf="client.habilitado == false"
                  >
                    <input
                      type="checkbox"
                      class="switch__toggle"
                      (click)="enableClient(client.cliente_id)"
                    />
                    <span class="switch__label"></span>
                  </label>
                </td>-->
                      <td>
                        <button
                          type="button"
                          class="btn btn-default btn-sm"
                          (click)="editModal(client.cliente_id)"
                        >
                          <i
                            class="fa fa-pencil-square-o text-info"
                            style="font-size: 20px"
                          ></i></button
                        >   <button
                        type="button"
                        class="btn btn-default btn-sm"
                        style="border: 1px solid black;"
                        routerLink="../listar-visitas"
                      >
                        V
                      </button>
  
                      
                      </td>
                    </tr>
                  </tbody>
                </table>
  
                <!-- <p>
                  Mostrando pagos {{ clientes.from }} a {{ clientes.to }} de
                  {{ clientes.total }}
                </p>
                <p>
                  Página {{ clientes.current_page }} de {{ clientes.last_page }}
                </p>
                <input
                  type="number"
                  style="width: 50px;"
                  [(ngModel)]="paginanum"
                  name="home"
                  required
                  min="0"
                  step="1"
                />
                <button (click)="searchPage(paginanum)">
                  ir
                </button>
                <br />
                <button (click)="prevPage()" [disabled]="!clientes.prev_page_url">
                  Anterior
                </button>
                <button (click)="nextPage()" [disabled]="!clientes.next_page_url">
                  Siguiente
                </button> -->
              </div>
            <!-- <p *ngIf="clientService.isLoading">Cargando...</p> -->
          </div>
         
        </div>
      </div>
    </div>
  </div>
  
